import { render, staticRenderFns } from "./weekCalendar.vue?vue&type=template&id=be463348&scoped=true"
import script from "./weekCalendar.vue?vue&type=script&lang=js"
export * from "./weekCalendar.vue?vue&type=script&lang=js"
import style0 from "./weekCalendar.vue?vue&type=style&index=0&id=be463348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be463348",
  null
  
)

export default component.exports